module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuElEQVRYhe3WsQ3CMBCF4UfEIBklFOzBJngU9nABI2SEjJAJLIREET9cBORYRPq/0rnkTrF1ZwEAUNth+cHuHAZJgyW5pRgmiwstdyLFPN/Rnr8KvtraQ9Jkax6ztazornHyKnZZtB+P6X0clubCex4DADvgY7yX1FvZY4phtjgf9ZtKMWQt1vv0pTCiT4W+fG+8H/nPbZy8CooGgP+2ZozX9HEl+MWaMV5T6UrwNSZiK4xxAAAk6QnmqCJSJGDbVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/80.png
// module id = FsjR
// module chunks = 1